export default "__VITE_ASSET__Bewc1tIx__"